export default class {
  constructor(){
    this.create()
  }

  create() {

    window.responsiveResizeObserver = new ResizeObserver((entries) => {
        entries.forEach(entry => {
            const imgWidth = entry.target.getBoundingClientRect().width;
            entry.target.parentNode.querySelectorAll('source').forEach((source) => {
                source.sizes = Math.ceil(imgWidth / window.innerWidth * 100) + 'vw'
            })
        })
    })

  }

  cleanup() {

    window.responsiveResizeObserver.disconnect()
    
  }

}
